// extracted by mini-css-extract-plugin
export var backButton = "_k-1";
export var content = "_k-d";
export var continueButton = "_k-7";
export var continueHint = "_k-8";
export var continueRow = "_k-6";
export var leftInner = "_k-0";
export var sidebarContent = "_k-5";
export var skipButton = "_k-c";
export var spacer = "_k-2";
export var spin = "_k-a";
export var spinner = "_k-9";
export var spinnerOverlay = "_k-b";
export var subtitle = "_k-4";
export var title = "_k-3";